import {Dialog, DialogActions, DialogContent, DialogTitle, Grid, IconButton,} from "@mui/material";
import {ReactComponent as WarningIcon} from "../../../../assets/images/warning_icon.svg";
import {FullButton} from "../../../../components/button/common_button";
import CommonColorUtils from "../../../../utils/common_colors";

export function AddToExistingNotAllowedDialog({
                                                  isDialogOpen,
                                                  handleCloseDialog,

                                              }) {
    return (
        <Dialog
            open={isDialogOpen}
            onClose={handleCloseDialog}
            sx={{
                "& .MuiDialog-paper": {
                    width: "500px",
                    maxHeight: "600px",
                    borderRadius: "8px"
                },
            }}
        >
            <DialogTitle>
                <div style={{display: "flex", gap: "10px", alignItems: "center"}}>
                    <WarningIcon
                        style={{width: "40px", height: "40px"}}
                    />
                    <span
                        style={{
                            fontSize: "20px",
                            fontWeight: 600,
                            fontFamily: "Inter, Arial, sans-serif",
                        }}>   {"Add to Existing Task not allowed"}</span>
                </div>
            </DialogTitle>
            <DialogContent>
                You have selected more than 1 vendor location names. To add to an existing task, please make sure you’re
                selecting orders belonging to 1 vendor location.
            </DialogContent>
            <DialogActions
                style={{
                    height: "50px",
                    paddingBottom: "20px",
                    backgroundColor: '#F7F7F9',
                }}>
                <FullButton
                    buttonText={"Ok, got it"}
                    activeColor={CommonColorUtils.primaryErrorDarkColor}
                    buttonTextColor={CommonColorUtils.primaryKWhite}
                    active={true}
                    height={"48px"}
                    width={"100px"}
                    customCursor={"pointer"}
                    isDisable={false}
                    handleOnPress={handleCloseDialog}
                />
            </DialogActions>
        </Dialog>
    );
}
